"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dialogsReducer = void 0;

var _reduxUtils = require("@dealersocket/redux-utils");

var sliceName = 'dialogsSlice';
var initialState = {
  open: {}
};
var dialogsReducer = (0, _reduxUtils.createAndMergeSliceReducer)(sliceName, initialState);
exports.dialogsReducer = dialogsReducer;